<template>
    <div ref="map" id="mapa">
        <slot></slot>
    </div>
</template>

<script>
  export default {
    name: "google-map",
    props: ['zoom', 'center', 'mapStyles', 'bounds'],
    data() {
      return {
        googleMap: null,
        googleMapPromise: true,
        defaultCenter: {lat: 51.9570078, lng: 17.8513354}
      }
    },
    computed: {
      mapElement() {
        return this.$refs['map']
      },
    },
    watch: {
      // 'googleMap.zoom'(newZoom, oldZoom) {
      //   if(Math.round(newZoom) != Math.round(oldZoom)) {
      //     this.$emit('update:zoom', newZoom);
      //   }
      //
      // },
      zoom(newZoom) {
        this.googleMap.setZoom(newZoom);
      },
      // 'googleMap.center'(newCenter) {
      //   // this.$emit('update:center', newCenter);
      // },
      center(newCenter) {
        this.googleMap.setCenter(newCenter);
      },
      bounds(newBounds) {
        this.googleMap.fitBounds(newBounds);
      }
    },
    methods: {
      createMap() {
        this.googleMapPromise = new Promise((resolve, reject) => {
          this.googleMap = new google.maps.Map(this.mapElement, {
            zoom: this.zoom,
            center: this.center,
            styles: this.mapStyles,
            disableDefaultUI: true,
            gestureHandling: 'greedy'
          })
          if(this.bounds)
            this.googleMap.fitBounds(this.bounds)
          this.forwardEvents();
          this.$emit('mapCreated', this.googleMap)
          resolve(this.googleMap);
        });
      },

      createMarkers() {
        if(! this.$slots.default) return;
        for(let marker of this.$slots.default) {
          marker.componentInstance.markerElement.setMap(this.googleMap)
        }
      },

      forwardEvents() {
        let centerChangedTimeout = null;
        let boundsChangedTimeout = null;
        this.googleMap.addListener('bounds_changed', () => {
          clearTimeout(boundsChangedTimeout);
          boundsChangedTimeout = setTimeout(() => {
            this.$emit('bounds_changed', this.googleMap.getBounds())
            this.$emit('center_changed', this.googleMap.getBounds())
            this.$emit('update:zoom', this.googleMap.getZoom());
            this.$emit('update:center', this.googleMap.getCenter());
          }, 200);
        })
        // this.googleMap.addListener('center_changed', () => {
        //   clearTimeout(centerChangedTimeout);
        //   centerChangedTimeout = setTimeout(() => {
        //     this.$emit('center_changed', this.googleMap.getBounds())
        //   }, 200);
        // })
      }
    },
    mounted() {
      this.$googleApiPromise.then((google) => {
        this.createMap();
        this.createMarkers();
      })
    }
  }
</script>

<style scoped>

</style>